const urls = {
  "weeklyRaffle": "#",
  "tofuNFT": "#",
  "mailContact": "hi@moonfit.xyz",
  "mediaKit": "https://drive.google.com/drive/folders/11W-cXD_SxNOqcabLcgRGGIlv0Kya1ROO",
  "twitterOfficial": "https://twitter.com/MoonFitOfficial"
}

export default urls
